// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-card--disabled[data-v-ef27a538]{background-color:#e0e0e0!important}.text-multiline-ellipsis[data-v-ef27a538]{-webkit-line-clamp:5;-webkit-box-orient:vertical;display:-webkit-box;line-height:1.2em;margin:1em 0;overflow:hidden;padding:0 1em;text-overflow:ellipsis}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
